import { default as validateLogin } from '../LoginForm/validate';
import { default as validateRegistration } from '../RegistrationForm/validate';

export default () =>
    (values = {}, props) => {
        const errors = {};
        
        if (values.formType === 'login') {
            const { logonId, ...rest } = validateLogin({ logonId: values.logonId, ...values.login }, props);
            errors.logonId = logonId;
            errors.login = rest;
        } else if (values.formType === 'registration') {
            const { registrationEmail, ...rest } = validateRegistration({ registrationEmail: values.registrationEmail, ...values.registration }, props);
            errors.registrationEmail = registrationEmail;
            errors.registration = rest;
        } else {
            const logonIdFieldName = 'guestEmail';
            const { logonId } = validateLogin({ logonId: values[logonIdFieldName] }, props);
            errors[logonIdFieldName] = logonId;
        }

        return errors;
    };
